import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useCopyToClipboard } from './hooks/useCopyToClipboard';
import XIcon from './XIcon';
import Analytics from '../common/Analytics';
import './XCopyButton.css';

const BASE_URL = 'https://xrpscan.com';
const GA_ACTION_NAME = 'CopyButton';

const XCopyButton = (props) => {
    const { text, url, size } = props;
    const [ isTextCopied, copyText ] = useCopyToClipboard();
    const [ isURLCopied, copyURL ] = useCopyToClipboard();

    let textButton = <></>;
    let urlButton = <></>;

    if (typeof text === 'string') {
        textButton = <>
            <OverlayTrigger overlay={<Tooltip id="tooltip-copy-text">{isTextCopied ? "Copied" : "Copy"}</Tooltip>}>
                <span onClick={() => copyText(text)} className='copy-button ml-1 mr-1'>
                    <XIcon
                        icon="copy"
                        size={size}
                        className={isTextCopied ? 'text-primary fa-flip' : ''}
                    />
                </span>
            </OverlayTrigger>
        </>
    }
    if (typeof url === 'string') {
        const fullURL = `${BASE_URL}${url}`;
        urlButton = <>
            <OverlayTrigger overlay={<Tooltip id="tooltip-copy-url">{isURLCopied ? "Copied" : "Copy"}</Tooltip>}>
                <span onClick={() => copyURL(fullURL)} className='copy-button ml-1 mr-1'>
                    <XIcon
                        icon="link"
                        size={size}
                        className={isURLCopied ? 'text-primary fa-flip' : ''}
                    />
                </span>
            </OverlayTrigger>
        </>
    }

    // Analytics
    if (isTextCopied) {
        Analytics.event({action: GA_ACTION_NAME, category: 'TextCopy', label: text});
    }
    if (isURLCopied) {
        Analytics.event({action: GA_ACTION_NAME, category: 'URLCopy', label: url});
    }
    const copyButtons = <>{textButton}{urlButton}</>
    return copyButtons;
}

XCopyButton.defaultProps = {
    size: 'sm',
}

XCopyButton.propTypes = {
    text: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
    size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
}

export default XCopyButton;